var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2523 13.0734H8.71559C7.48996 13.0734 6.53669 12.1201 6.53669 10.8945V2.1789C6.53669 0.987312 7.48996 0 8.71559 0H13.4819C13.8905 0 14.3331 0.204272 14.6395 0.510679L16.9205 2.79171C17.2269 3.09812 17.4312 3.54071 17.4312 3.94925V10.8945C17.4312 12.1201 16.4439 13.0734 15.2523 13.0734ZM2.1789 4.35779H5.44724V5.99197H2.1789C1.87249 5.99197 1.63417 6.26433 1.63417 6.53669V15.2523C1.63417 15.5587 1.87249 15.797 2.1789 15.797H8.71559C8.98795 15.797 9.26031 15.5587 9.26031 15.2523V14.1628H10.8945V15.2523C10.8945 16.4779 9.90717 17.4312 8.71559 17.4312H2.1789C0.953267 17.4312 0 16.4779 0 15.2523V6.53669C0 5.34511 0.953267 4.35779 2.1789 4.35779Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.54ce3bf791f9135284964fcf5ea7309c.svg";
export { ForwardRef as ReactComponent };